import Col from 'react-bootstrap/Col';
import {Nav, Row, Tab,} from 'react-bootstrap';
import './ReportSection.css';
import VendorAssignmentReportPage from './VendorAssignmentReportPage';
import VendorCLAssignmentReportPage from './VendorCLAssignmentReportPage';
import CLRErodeDataReportPage from './CLRErodeDataReportPage';
import DeptTransactionDetailsReportPage from './DeptTransactionDetailsReportPage';
import SecurityReportPage from './SecurityReportPage';
import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";

function ReportSectionSidebar() {
    // const [loadModule,setLoadModule] = useState(1);
    // const [rowData,setRowData] = useState({});
    const navigate = useNavigate();
    const [loadModule, setLoadModule] = useState("");
    const [roleKey, setRoleKey] = useState("");
    const [role, setRole] = useState("");
    const dataInRow = useRef({});

    const HandleEvent = (num) => {

        setLoadModule(num);
    }

    const HandleEventGetId = (num, row) => {


        dataInRow.current = row;
        setLoadModule(num);
        // setRowData(row);


    }

    useEffect(() => {
        const userrole = localStorage.getItem('role');
        if (userrole == '' || userrole == null) {
            navigate('/', {replace: true});
            return;
        } else {
            setRole(userrole);
            switch (role) {
                case 'Admin':
                    setRoleKey(1);
                    setLoadModule(1);
                    break;
                case 'Vendor':
                    setRoleKey(2);
                    setLoadModule(2);
                    break;
                case 'Security':
                    setRoleKey(5);
                    setLoadModule(5);
                    break;
                case 'Department':
                    setRoleKey(4);
                    setLoadModule(4);
                    break;
                case 'Supervisor':
                    setRoleKey(7);
                    setLoadModule(7);
                    break;
            }
        }

    }, [roleKey, role])


    return (

        <Row>
            {roleKey != "" &&
                <Tab.Container id="left-tabs-example" className="navMenuRadius" defaultActiveKey={roleKey}>
                    {/* <Col xs={2} sm={2} md={2} lg={2} className='tabNavBG'> */}
                    <Nav variant="pills" className="flex-column d-flex justify-content-between ">
                        {/*<img src={cklogo} className="ckLogoImg" alt="" />*/}

                        {role == 'Admin' &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('1')}>
                                <Nav.Link className='navMenuRadius' eventKey="1">CLR Erode Data</Nav.Link>
                            </Nav.Item>}
                        {(role == 'Security' || role == 'Admin') &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('2')}>
                                <Nav.Link className='navMenuRadius' eventKey="2">Security Attendance Data</Nav.Link>
                            </Nav.Item>}
                        {role == 'Admin' &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('3')}>
                                <Nav.Link className='navMenuRadius' eventKey="3">Dept Attendance Data</Nav.Link>
                            </Nav.Item>}
                        {role == 'Admin' &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('4')}>
                                <Nav.Link className='navMenuRadius' eventKey="4"> Vendor Assigned Data </Nav.Link>
                            </Nav.Item>}
                        {/* {role == 'Admin' &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('5')}>
                            <Nav.Link className='navMenuRadius' eventKey="5">Vendor CL Assigned Data</Nav.Link>
                                <Nav.Link className='navMenuRadius' eventKey="2">Vendor Assigned Data</Nav.Link>
                            </Nav.Item>} */}
                        {(role == 'Vendor' || role == 'Admin') &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('5')}>
                                <Nav.Link className='navMenuRadius' eventKey="5">Vendor CL Assigned Data</Nav.Link>
                            </Nav.Item>}
                        {/* {(role == 'Supervisor' || role == 'Admin') &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('7')}>
                            <Nav.Link className='navMenuRadius' eventKey="7">Vendor Assignment</Nav.Link>
                        </Nav.Item>}
                        {(role == 'Vendor' || role == 'Admin') &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('6')}>
                            <Nav.Link className='navMenuRadius' eventKey="6">Vendor CL Assignment</Nav.Link>
                        </Nav.Item>}
                        {(role == 'Department' || role == 'Admin') &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('4')}>
                            <Nav.Link className='navMenuRadius' eventKey="4">Department</Nav.Link>
                        </Nav.Item>}
                        {(role == 'Security' || role == 'Admin') &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('5')}>
                            <Nav.Link className='navMenuRadius' eventKey="5">Security</Nav.Link>
                        </Nav.Item>}
                        {role == 'Admin' &&
                            <Nav.Item className='noBorderRadius' onClick={e => setLoadModule('13')}>
                                <Nav.Link className='navMenuRadius' eventKey="9">Report Section</Nav.Link>
                            </Nav.Item>} */}
                    </Nav>
                    {/* </Col> */}
                    <Col xs={10} sm={10} md={10} lg={10} className='tabContentBG'>
                        <Tab.Content>
                            {/* <Tab.Pane eventKey="2">
                            {loadModule== '2'&& <VendorAssignmentReportPage/>}
                        </Tab.Pane>
                        <Tab.Pane eventKey="3">
                            {loadModule == '3'&& <VendorCLAssignmentReportPage/>}
                        </Tab.Pane> */}
                            <Tab.Pane eventKey="1">
                                {loadModule == '1' && <CLRErodeDataReportPage/>}
                                {/* {loadModule=='1' && <SecurityReportPage />} */}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2">
                                {loadModule == '2' && <SecurityReportPage/>}
                            </Tab.Pane>
                            <Tab.Pane eventKey="3">
                                {loadModule == '3' && <DeptTransactionDetailsReportPage/>}
                            </Tab.Pane>
                            <Tab.Pane eventKey="4">
                                {loadModule == '4' && <VendorAssignmentReportPage/>}
                            </Tab.Pane>
                            <Tab.Pane eventKey="5">
                                {loadModule == '5' && <VendorCLAssignmentReportPage/>}
                            </Tab.Pane>
                            {/*<Tab.Pane eventKey="3">*/}
                            {/*    {loadModule=='3' && <DailyShift />}*/}
                            {/*</Tab.Pane>*/}
                            {/* <Tab.Pane eventKey="4">
                            {loadModule == '4' && <Department/>}
                        </Tab.Pane>
                        <Tab.Pane eventKey="5">
                            {loadModule == '5' && <Security/>}
                        </Tab.Pane>
                        <Tab.Pane eventKey="6">
                            {loadModule == '6' && <VendorCLAssignmentList HandleEvent={HandleEvent}/>}
                            {loadModule == '6.1' && <VendorCLAssignment/>}
                        </Tab.Pane>
                        <Tab.Pane eventKey="7">
                            {loadModule == '7' && <VendorAssignmentList HandleEvent={HandleEvent}/>}
                            {loadModule == '7.1' && <VendorAssignment/>}
                        </Tab.Pane> */}
                            {/*<Tab.Pane eventKey="8">*/}
                            {/*    <LabourMasterDataTable />*/}
                            {/*</Tab.Pane>*/}
                            {/* <Tab.Pane eventKey="10">
                            <MasterVendor />
                        </Tab.Pane> */}
                        </Tab.Content>
                    </Col>
                </Tab.Container>}
        </Row>

    );
}

export default ReportSectionSidebar;